import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      setUser(data);
      toast.success("Mot de passe mis à jour");
      navigate(data.role === "traveler" ? "/mes-sejours" : "/espace-hote");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-md mx-auto px-5 py-16">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-rose-brand mb-3"><KeyRound className="w-4 h-4" /> Sécurité</span>
        <h1 className="font-serif text-4xl text-olive">{user?.must_change_password ? "Choisissez votre mot de passe" : "Changer mon mot de passe"}</h1>
        {user?.must_change_password && <p className="text-muted-foreground mt-2" data-testid="must-change-notice">Bienvenue ! Pour sécuriser votre compte, remplacez le mot de passe temporaire reçu par email.</p>}
        <form onSubmit={submit} className="mt-8 space-y-4 bg-white rounded-2xl border border-border p-6" data-testid="change-password-form">
          <div><Label>Mot de passe actuel (temporaire)</Label><Input type="password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="mt-1 h-11" data-testid="current-password" /></div>
          <div><Label>Nouveau mot de passe (8 caractères min.)</Label><Input type="password" required minLength={8} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="mt-1 h-11" data-testid="new-password" /></div>
          <div><Label>Confirmer</Label><Input type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="mt-1 h-11" data-testid="confirm-password" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-olive text-white rounded-full" data-testid="change-password-submit">{busy ? "..." : "Enregistrer"}</Button>
        </form>
      </div>
    </div>
  );
}
